<template>

  <div class="no-table-box no-card-base">
    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="Business" name="Business Contacts" class="tab-section">
        <div id="contacts-view">
          <div class="box flex align-center">
            <div class="list-search-input" style="width:100%;">
              <div class="box">
                <el-input
                  v-model="search"
                  placeholder="Search Name / Number"
                  clearable
                />
              </div>
            </div>
          </div>

          <div style="height: 285px; width: 100%;">
            <vxe-grid
              round
              class="user-stats-table vxe-contacts"
              border="inner"
              ref="xGrid"
              height="100%"
              auto-resize
              show-overflow="tooltip"
              :show-header="false"
              empty-text="No Data"
              :data="contactList"
              :scroll-y="{enabled: true, gt: 50, oSize: 0}"
              :loading="contactsLoading"
              :columns="tableColumns">
            </vxe-grid>
          </div>

        </div>
      </el-tab-pane>

      <el-tab-pane label="Personal" name="Personal Contacts" class="tab-section">
        <div id="personal-contacts-view">
          <div class="box flex align-center" style="width: 100%;">
            <el-input
              style="margin-right: 5px; width: 100%;"
              v-model="searchPersonal"
              placeholder="Search Name / Number / Company"
              clearable
            />
            <div class="add-contact-button">
              <el-tooltip content="Add Contacts" placement="top">
                <el-button
                  type="default"
                  class="table-action-button"
                  icon="el-icon-plus"
                  @click="showModal('Create')">
                </el-button>
              </el-tooltip>
            </div>
          </div>

          <div style="height: 285px; width: 100%;">
            <vxe-grid
              round
              @cell-click="cellClicked"
              class="user-stats-table vxe-contacts"
              border="inner"
              ref="xGrid"
              height="100%"
              auto-resize
              show-overflow="tooltip"
              :show-header="false"
              empty-text="No Data"
              :data="filteredListPersonal"
              :scroll-y="{enabled: true, gt: 50, oSize: 0}"
              :loading="contactsLoading"
              :columns="tableColumnsPersonal">
            </vxe-grid>
          </div>
        </div>
        <contact-form
          :visible="contactModalVisible"
          :context="modalContext"
          :recordId="modalModelId"
          @modalClosed="contactModalVisible = false">
        </contact-form>
      </el-tab-pane>
    </el-tabs>
  </div>


</template>

<script>

  import ContactForm from './components/contact-form'
  import {mapGetters} from "vuex";
  import {globalEventBus} from "../../../../globalEventBus";
  import debounce from 'lodash/debounce';
  import feathersClient from "@/feathers/feathers-client";
  import {phoneNumberFormatter} from "@/globals/globals";

  export default{
    name: 'MyContacts',
    components: {ContactForm},
    data(){
      return {
        search: '',
        searchActive: false,
        searchPersonal: '',
        personalContactsLoading: false,
        selectedBranch: null,
        contactsCount: '',
        contactsLoading: false,
        personalContactsCount: '',
        activeTab: 'Business Contacts',
        contactModalVisible: false,
        modalContext: '',
        modalModelId: '',
        userConfigured: true,
        branchOptions: [],
        contactList: [],
        tableColumns: [
          {
            field: 'name',
            title: 'Name',
            showOverflow: true,
            width: 200,
            sortable: true
          },
          {
            field: 'number',
            title: 'Ext',
            showOverflow: true,
            width: 75,
            sortable: true
          },
          {
            field: 'dial',
            width: 40,
            slots: {
              default: ({row}) => {
                return [
                  <el-button
                    class="table-action-button"
                    onClick={() => this.dialCall(row.number)}>
                    <v-svg class="voxo-green" sprite="phone"/>
                  </el-button>
                ]
              }
            }
          },
          {
            field: ''
          }
        ],
        tableColumnsPersonal: [
          {
            field: 'FIRSTNAME',
            title: 'Name',
            showOverflow: true,
            sortable: true,
            width: 150,
            slots: {
              default: ({row}) => {
                return [
                  <div clase="contact-info">
                    <div class="contact-name">
                      {row.FIRSTNAME} {row.LASTNAME}
                    </div>
                    <p class="text-muted mb-0 mt-0" style="font-size: 10pt;">{row.COMPANY}</p>
                  </div>
                ]
              }
            }
          },
          {
            field: 'PHONE1',
            title: 'Number',
            showOverflow: true,
            width: 140,
            sortable: true,
            slots: {
              default: ({row}) => {
                return [
                  <span>{this.numberFormatter(row.PHONE1)}</span>
                ]
              }
            }
          },
          {
            field: 'call',
            width: 40,
            slots: {
              default: ({row}) => {
                return [
                  <el-button
                    class="table-action-button"
                    onClick={() => this.dialCall(row.PHONE1)}
                    style="box-shadow: none;">
                  <v-svg class="voxo-green" sprite="phone"/>
                </el-button>
                ]
              }
            }
          },
          {
            field: ''
          }
        ]
      }
    },
    computed: {
      ...mapGetters('phonebook-entries', {getPhonebookEntriesList: 'find'}),
      selectedTenant(){
        return this.$store.getters.selectedTenant;
      },
      softphoneEnabled(){
        return this.$store.state.softphoneEnabled;
      },
      personalContactList(){
        //in case an entry is empty we make sure details exists
        if(this.user.hasOwnProperty('myExtension')){
          const list = this.getPhonebookEntriesList({
            query: {
              hasDetails: true,
              phonebookId: this.user.myExtension.omniaPhonebookId,
              $sort: {
                FIRSTNAME: 1
              }
            }
          }).data;
          this.personalContactsCount = list.length;
          return list;
        }
        return [];
      },
      user(){
        return this.$store.state.auth.user;
      },
      filteredListPersonal(){
        return this.filteredDataPersonal();
      }
    },
    watch: {
      search: debounce(function () {
        this.searchContacts();
      }, 500)
    },
    methods: {
      filteredDataPersonal(){
        const filteredList = this.personalContactList.filter(data => !this.searchPersonal
          || data.FIRSTNAME.toLowerCase().includes(this.searchPersonal.toLowerCase())
          || data.LASTNAME.toLowerCase().includes(this.searchPersonal.toLowerCase())
          || data.PHONE1.toLowerCase().includes(this.searchPersonal.toLowerCase())
          || data.COMPANY.toLowerCase().includes(this.searchPersonal.toLowerCase())
        );
        this.personalContactsCount = filteredList.length;
        return filteredList;
      },
      searchContacts(){
        if(this.search.length){
          this.contactList = this.allContacts.filter(item =>
            item.name.toLowerCase().includes(this.search.toLowerCase())
            || item.number.includes(this.search)
          )
        } else{
          this.contactList = [...this.allContacts];
        }
      },
      showModal(context, editId = null) {
        this.contactModalVisible = true;
        this.modalContext = context;
        this.modalModelId = editId;
      },
      dialCall(number){
        globalEventBus.$emit('dialSoftphone', number);
        globalEventBus.$emit('crmWidgetDial', number);
      },
      numberFormatter(number) {
        if(number){
          return phoneNumberFormatter(number);
        }
      },
      async loadContacts(){
        //get the contacts by Branch
        this.contactsLoading = true;
        feathersClient.service('extensions').find({
          query: {
            queryPhonebook: true,
            tenantId: this.user.myExtension.tenantId
          }
        }).then (res => {
          this.allContacts = [...res];
          this.contactList = [...res];
          this.contactsLoading = false;
        });
      },
      cellClicked(data) {
        if(data.column.property !== 'call'){
          this.showModal('Edit', data.row.id);
        }
      },
    },
    created(){
      if(this.user){
        if(!this.user.hasOwnProperty('myExtension')){
          this.$notify({
            title: 'Warning',
            message: 'Your Account Has No Assigned Extension',
            type: 'warning'
          });
          this.userConfigured = false;
        }
      }
    },
    mounted(){
      this.loadContacts();
    }
  }

</script>

<style lang="scss" scoped>

  @import '../../../../assets/scss/variables';

  .el-table td{
    padding: 0;
  }

  .contact-item{
    padding: 0;
    min-height: 50px;
  }

  .list-search-input{
    //width: 25%;
    min-width: 300px;
    margin-top: 0px;
    margin-left: 0px !important;
  }

  .el-tabs--top{
    //margin-top: 10px;
    margin-left: 0px !important;
  }

  .card-base, .no-card-base form{
    padding-top: 0px;
  }

  .table-box, .no-table-box{
    height: calc(100% - .7em);
    overflow: hidden;
  }

  #recent-calls-view{
    height: 100%;
  }

  .item-list{
    max-height: calc(100vh - 20em);
    overflow-y: auto;
  }

  .item-list-contacts{
    margin-top: 10px;
    max-height: calc(100vh - 16em);
    overflow-y: auto;
  }

  .add-contact-button{
    text-align: right;
    margin-left: 0px !important;
    .el-button {
      width: 38px;
      height: 38px;
    }
  }

  .inbound-outbound-filter{
    margin-bottom: 20px;
  }

  .tab-label{
    position: relative;
    display: flex;
  }

  .number-badge{
    margin-top: -8px;
  }

  .filter-columns{
    display: flex;
  }

  .filter-checkbox{
    display: block;
  }

  .table-container{
    height: calc(100vh - 14.75em);
  }

  @media (max-width: 959px){
    #recent-calls-view, #contacts-view{
      .box{
        flex-wrap: wrap;
      }
    }
  }

  @media (max-width: 499px){
    .el-checkbox-group{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .box{
      .black-text{
        flex-basis: 100%;
        margin-bottom: 20px;
      }
      .call-item{
        margin-right: 10px;
      }
    }

    #calls-count{
      text-align:center !important;
    }

    .inbound-outbound-filter{
      display: flex;
      justify-content: center;
    }
  }

</style>
